export const BROWSE_STRATEGIES_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Browse Strategies',
  FILTERED_RESULTS: 'Filtered Strategy Results',
  CLICKED_RESULT: 'Clicked Strategy Result'
}

export const STRATEGY_WIZARD_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Strategy Wizard',
  SUBMITTED: 'Submitted Strategy Wizard'
}

export const STRATEGY_DETAIL_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Strategy',
  VIEWED_SHARED_PAGE: 'Viewed Shared Strategy Page'
}

export const SAVED_STRATEGY_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Saved Strategy',
  CLICKED_SAVE_CHANGES: 'Clicked Save Changes',
  CLICKED_MOVE_TO_TRASH: 'Clicked Move to Trash'
}
